import React from "react";
import InlineDropdown from "./InlineDropdown";

export const DATE_BASIS = {
  CREATED: "created_date",
  DUE: "due_date",
};

export const DATE_BASIS_OPTIONS = [
  { label: "Created on", key: DATE_BASIS.CREATED },
  { label: "Due on", key: DATE_BASIS.DUE },
];

/**
 * Thin wrapper around InlineDropdown preconfigured for "Created on / Due on" selection.
 * For other dropdowns with the same UI style, use <InlineDropdown /> directly.
 *
 * @param {{
 *   value: "created_date" | "due_date",
 *   onChange: (value: string) => void,
 *   className?: string,
 * }} props
 */
const DateBasisDropdown = ({ value, onChange, className }) => (
  <InlineDropdown
    value={value}
    onChange={onChange}
    options={DATE_BASIS_OPTIONS}
    placeholder="Created on"
    className={className}
  />
);

export default DateBasisDropdown;
